// Значок подбора слов по теме. Плашка-ссылка TopicCardsEntry заменена вкладками CreationTabs (2026-10-16).
export function TopicIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <rect x="3" y="6" width="13" height="15" rx="3" />
      <path d="M8 3h10a3 3 0 0 1 3 3v10M7 12h5M7 16h3M17 7l.8 2.2L20 10l-2.2.8L17 13l-.8-2.2L14 10l2.2-.8L17 7Z" />
    </svg>
  );
}
